<template>
  <div class="counters-wraper" @click="emit('onClick')">
    <div class="counters-group">
      <div class="label-and-counter">
        <div
          class="checkpoints-counter-wraper counter"
          :class="{
            'counter-red-ver': (apprenticeActive === 0
              || professionalActive === 0
              || coachActive === 0
              || masterActive === 0)
          }"
        >
          <div class="level level-apprentice">
            <span v-if="apprenticeActive > 99">99+</span>
            <span v-else>{{ apprenticeActive }}</span>
            <div
              class="badge-counter-draft"
              :class="{
                'nine-plus-draft': apprenticeDraft > 9
              }"
            >
              <span v-if="apprenticeDraft > 9">9+</span>
              <span v-else-if="apprenticeDraft === 0">-</span>
              <span v-else>{{ apprenticeDraft }}</span>
            </div>
          </div>
          <div class="level level-professional">
            <span v-if="professionalActive > 99">99+</span>
            <span v-else>{{ professionalActive }}</span>
            <div
              class="badge-counter-draft"
              :class="{
                'nine-plus-draft': professionalDraft > 9
              }"
            >
              <span v-if="professionalDraft > 9">9+</span>
              <span v-else-if="professionalDraft === 0">-</span>
              <span v-else>{{ professionalDraft }}</span>
            </div>
          </div>
          <div class="level level-coach">
            <span v-if="coachActive > 99">99+</span>
            <span v-else>{{ coachActive }}</span>
            <div
              class="badge-counter-draft"
              :class="{
                'nine-plus-draft': coachDraft > 9
              }"
            >
              <span v-if="coachDraft > 9">9+</span>
              <span v-else-if="coachDraft === 0">-</span>
              <span v-else>{{ coachDraft }}</span>
            </div>
          </div>
          <div class="level level-master">
            <span v-if="masterActive > 99">99+</span>
            <span v-else>{{ masterActive }}</span>
            <div
              class="badge-counter-draft"
              :class="{
                'nine-plus-draft': masterDraft > 9
              }"
            >
              <span v-if="masterDraft > 9">9+</span>
              <span v-else-if="masterDraft === 0">-</span>
              <span v-else>{{ masterDraft }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  // New prop names (used in MasteredResponsibilityTable)
  countApprenticeCheckpoints: {
    type: Number,
    default: undefined,
  },
  countProfessionalCheckpoints: {
    type: Number,
    default: undefined,
  },
  countCoachCheckpoints: {
    type: Number,
    default: undefined,
  },
  countMasterCheckpoints: {
    type: Number,
    default: undefined,
  },
  draftApprenticeCheckpoints: {
    type: Number,
    default: undefined,
  },
  draftProfessionalCheckpoints: {
    type: Number,
    default: undefined,
  },
  draftCoachCheckpoints: {
    type: Number,
    default: undefined,
  },
  draftMasterCheckpoints: {
    type: Number,
    default: undefined,
  },
  countApprentice: {
    type: Number,
    default: undefined,
  },
  countProfessional: {
    type: Number,
    default: undefined,
  },
  countCoach: {
    type: Number,
    default: undefined,
  },
  countMaster: {
    type: Number,
    default: undefined,
  },
  // Old prop names (for backward compatibility)
  apprentice_active: {
    type: Number,
    default: 0,
  },
  apprentice_draft: {
    type: Number,
    default: 0,
  },
  professional_active: {
    type: Number,
    default: 0,
  },
  professional_draft: {
    type: Number,
    default: 0,
  },
  coach_active: {
    type: Number,
    default: 0,
  },
  coach_draft: {
    type: Number,
    default: 0,
  },
  master_active: {
    type: Number,
    default: 0,
  },
  master_draft: {
    type: Number,
    default: 0,
  },
});

const emit = defineEmits(['onClick']);

// Computed properties to map new props to old prop names for template
const apprenticeActive = computed(() => {
  return props.countApprenticeCheckpoints ?? props.countApprentice ?? props.apprentice_active ?? 0;
});

const professionalActive = computed(() => {
  return props.countProfessionalCheckpoints ?? props.countProfessional ?? props.professional_active ?? 0;
});

const coachActive = computed(() => {
  return props.countCoachCheckpoints ?? props.countCoach ?? props.coach_active ?? 0;
});

const masterActive = computed(() => {
  return props.countMasterCheckpoints ?? props.countMaster ?? props.master_active ?? 0;
});

const apprenticeDraft = computed(() => {
  return props.draftApprenticeCheckpoints ?? props.apprentice_draft ?? 0;
});

const professionalDraft = computed(() => {
  return props.draftProfessionalCheckpoints ?? props.professional_draft ?? 0;
});

const coachDraft = computed(() => {
  return props.draftCoachCheckpoints ?? props.coach_draft ?? 0;
});

const masterDraft = computed(() => {
  return props.draftMasterCheckpoints ?? props.master_draft ?? 0;
});
</script>
<style>
.checkpoints-counter-wraper.counter {
  display: flex;
  column-gap: 3px;
  width: 136px;
  border: 1px solid #EAECF0;
  padding: 8px 0px 2px 3px;
  border-radius: 8px;
  background-color: #F9FAFB;
}
.counter-red-ver {
  border: 1px solid #D92D20 !important;
  background-color: #F7DDDD !important;
}
.counters-wraper {
  padding: 10px;
}
.counter-hover {
  border-radius: 8px;
  background-color: #f2edff !important;
  cursor: url("../assets/cursorArrow.svg"), auto !important;
  width: 136px;
}
.checkpoints-counter-wraper.counter:hover {
  border: 1px solid #f2edff !important;
}
.checkpoints-counter-wraper.counter-red-ver:hover {
  border: 1px solid #f2edff !important;
}
.checkpoints-counter-wraper:hover {
  border-radius: 8px;
  background-color: #f2edff !important;
  cursor: url("../assets/cursorArrow.svg"), auto !important;
  width: 136px;
}
.counters-group {
  display: flex;
  flex-direction: column;
  row-gap: 15px;
}
.label-and-counter {
  display: flex;
  flex-direction: column;
  row-gap: 5px;
}
.label {
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: left;
  color: #475467;
}
.checkpoints-counter-wraper .level {
  height: 30px;
  min-width: 30px;
  border: 1px solid;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  position: relative; /* Add this for badge positioning */
}
.badge-counter-draft {
  position: absolute;
  top: -8px;
  right: 1px;
  background-color: #D9D9D9;
  border-radius: 2px;
  padding: 0px 5px;
  font-size: 8px;
  line-height: 14px;
  color: #344054;
  z-index: 10;
  font-family: Family/Font-Family;
  font-weight: 400;
  font-style: Regular;
  text-align: center;
}
.nine-plus-draft {
  padding: 0px 3px !important;
}
.checkpoints-counter-wraper .level-apprentice {
  border-color: #E58700;
  background-color: #FFF5D3;
  color: #E58700;
  font-family: Inter;
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
}
.checkpoints-counter-wraper .level-professional {
  border-color: #00B813;
  background-color: #F3FFF9;
  color: #00B813;
  font-family: Inter;
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
}
.checkpoints-counter-wraper .level-coach {
  border-color: #00A3FF;
  background-color: #EFFEFF;
  color: #00A3FF;
  font-family: Inter;
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
}
.checkpoints-counter-wraper .level-master {
  border-color: #2E1EC1;
  background-color: #F2F3FF;
  color: #2E1EC1;
  font-family: Inter;
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
}
</style>